import { render, staticRenderFns } from "./sa-index.vue?vue&type=template&id=7c471f2f&"
import script from "./sa-index.js?vue&type=script&lang=js&"
export * from "./sa-index.js?vue&type=script&lang=js&"
import style0 from "./sa-index.css?vue&type=style&index=0&lang=css&"
import style1 from "./sa-theme.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports